import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";
import LiveTheAyahContent, {
  LiveTheAyahContentParameters,
} from "@components/layouts/content/LiveTheAyahContent";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<LiveTheAyahContentParameters>(props, ref);

  const { title, text, date } = getParameterValues(["title", "text", "date"]);

  return (
    <LiveTheAyahContent
      content={content}
      parameterValues={{
        title,
        text,
        date,
      }}
      isLoading={isLoading}
    />
  );
});

export const LiveAyahContentComponent: ContentComponent = {
  identifier: "COM:LIVETHEAYAH:CARD",
  component: Component,
};
